/* eslint-disable @typescript-eslint/no-explicit-any */
import { RaceTable } from 'features/Race/components'
import { guildVaultTableCoinColumns } from 'utils/columns'
import { useAppDispatch, useAppSelector, useUpdateEffect } from 'hooks'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { GetRaceListParams } from 'models'
import { NUMBER, STRING } from 'apps/constants'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'
import { notification } from 'antd'
import { useSelector } from 'react-redux'
import { errorTicketListTable, getTicketListTable } from 'apps/redux/userCreateRace/selector'
import { getTicketList } from 'apps/redux/userCreateRace/action'
import { GOLD, SILVER } from 'assets/images'

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TWENTY,
  page: NUMBER.ONE
}

function TableTicket() {
  const [api, contextHolder] = notification.useNotification()
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [dataTable, setDataTable] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(false)
  const [total, setTotal] = useState()
  const dispatch = useAppDispatch()
  const dataTicketTable = useSelector(getTicketListTable)
  const errorTicket = useSelector(errorTicketListTable)

  const memoizedResultListSelectionColumns = useMemo(() => {
    return guildVaultTableCoinColumns
  }, [profile])

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      setLoading(true)
      getListDataTable()
    }
  }, [params, profile.guild_id])

   useEffect(() => {
    if (errorTicket) {
      openNotification(STRING.ERROR, errorTicket)
    }
  }, [errorTicket])

  useEffect(() => {
    if (dataTicketTable?.records) {
      setLoading(false)
       const getAvatarByType = (type: string) => {
        switch (type) {
          case 'GOLD':
            return GOLD
          case 'SILVER':
            return SILVER
          default:
            return ''
        }
      }
      const formatData = dataTicketTable?.records.map((record: any) => {
        return {
          ...record,
          coin_type: record.ticket_type,
          avatar: getAvatarByType(record.ticket_type)
        }
      })
      setDataTable(params.page > NUMBER.ONE ? [...dataTable, ...formatData] : formatData)
      setTotal(dataTicketTable?.total || NUMBER.ZERO)
    }
  }, [dataTicketTable])

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })

    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const getListDataTable = async () => {
    dispatch(getTicketList({ guildId: profile.guild_id, params }))
  }

  useUpdateEffect(() => {
    setParams({ ...params, page: NUMBER.ONE })
  }, [])

  return (
    <div>
      {contextHolder}
      <RaceTable
        columns={memoizedResultListSelectionColumns}
        data={dataTable}
        raisePage={setParams}
        loader={!loading}
        params={params}
        checkLoadingPage={false}
        totalRace={total}
        currentUser={profile}
        noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
        isShowVipIcon={true}
      />
    </div>
  )
}

export default memo(TableTicket)
